import {DataFetcher} from '@aboutyou/data-fetcher';
import {useCurrentPageType} from '@aboutyou/router';
import React from 'react';
import {FooterDynamicView, FooterDynamicViewProps} from './FooterDynamicView';
import {useFooterDynamicData} from './useFooterDynamicData';

export const FooterDynamic: React.FC<FooterDynamicViewProps> = props => {
  const pageType = useCurrentPageType();

  if (
    pageType !== 'category' &&
    pageType !== 'story' &&
    pageType !== 'outfitDetail' &&
    pageType !== 'brandShop' &&
    pageType !== 'home'
  ) {
    return null;
  }

  return <FooterDynamicFetcher {...props} />;
};

const FooterDynamicFetcher: React.FC<FooterDynamicViewProps> = props => {
  return (
    <DataFetcher
      request={useFooterDynamicData()}
      Error={() => null}
      Loading={undefined}
      View={FooterDynamicView}
      viewProps={props}
    />
  );
};
